import { Drawer, type DrawerProps } from 'antd';
import type { FC } from 'react';

export const AppDrawer: FC<DrawerProps> = (props) => {
  return <Drawer {...props} />;
};
